<template>
  <div class="l-content-inner">
    <!-- 회원가입 -->
    <div class="p-member-wrap">
      <div class="c-hgroup is-pc">
        <h1 class="c-title-level1">노루페인트 PAINT PRO 아이디 찾기</h1>
      </div>

      <form action="">
        <div class="id-pw-find">
          <p class="find-result">
            <span class="text">
              {{ props.userInfo.j1kfrepre }} 님의 아이디는
            </span>
            <span class="text">
              <strong> {{ props.userInfo.custCd }} </strong>입니다.
            </span>
          </p>
        </div>

        <div class="c-btn-area">
          <a
            href="#"
            class="c-button type-secondary"
            @click.prevent="goToPwSearch"
          >
            <span>비밀번호 찾기</span>
          </a>
          <a href="#" class="c-button type-primary" @click.prevent="goToLogin">
            <span>로그인</span>
          </a>
        </div>
      </form>
    </div>
  </div>
</template>
<script setup name="idFindDomplete">
import { defineProps, onMounted } from "vue";
import { useRouter } from "vue-router";
import * as cmUtil from "@/utils/cmUtil.js";

const router = useRouter();

const props = defineProps({
  userInfo: {
    type: Object,
    required: true,
  },
});

onMounted(() => {});

const goToLogin = () => {
  cmUtil.setLocalStorage("REMEMBER_USER_ID", props.userInfo.custCd);
  router.push("/");
};

const goToPwSearch = () => {
  cmUtil.setLocalStorage("REMEMBER_USER_ID", props.userInfo.custCd);
  router.push("/member/pwdsrch");
};
</script>
